export enum Moeda {
  GUARANI = 'GUARANI',
  REAL = 'REAL',
  DOLAR = 'DOLAR',
  PESO = 'PESO'
}

// Configuracao centralizada de formatacao por moeda
// symbol: codigo ISO para o pipe currency do Angular
// digits: formato de casas decimais (Angular DecimalPipe format)
// locale: locale para formatacao correta de separadores (milhar/decimal)
// label: nome legivel para exibicao em dropdowns
export interface MoedaConfig {
  symbol: string;
  digits: string;
  locale: string;
  label: string;
}

export const MOEDA_CONFIG: Record<Moeda, MoedaConfig> = {
  [Moeda.GUARANI]: { symbol: 'PYG', digits: '1.0-0', locale: 'es-PY', label: 'Guarani' },
  [Moeda.REAL]: { symbol: 'BRL', digits: '1.2-2', locale: 'pt-BR', label: 'Real' },
  [Moeda.DOLAR]: { symbol: 'USD', digits: '1.2-2', locale: 'en-US', label: 'Dolar' },
  [Moeda.PESO]: { symbol: 'ARS', digits: '1.2-2', locale: 'es-AR', label: 'Peso Argentino' },
};

// Lista de moedas para uso em dropdowns (SelectItem)
export const MOEDA_OPTIONS = Object.values(Moeda).map(m => ({
  label: MOEDA_CONFIG[m].label,
  value: m
}));

export enum TipoRegimeContabil {
  REGIME_PRODUTOR_PEQUENO_PORTE = 'REGIME_PRODUTOR_PEQUENO_PORTE',
  REGIME_PRODUTOR_MEDIO_PORTE = 'REGIME_PRODUTOR_MEDIO_PORTE',
  REGIME_CONTABIL = 'REGIME_CONTABIL'
}

export enum TipoImprimir {
  PERGUNTAR = 'PERGUNTAR',
  IMPRIMIR = 'IMPRIMIR',
  NADA_A_FAZER = 'NADA_A_FAZER'
}
